import moment from 'moment';


export const TransHeaderConf = [

  {
    order: 1,
    des: "Sender Name",
    label: "Sender",
    display: true,
    sort: false,
    search: false,
    path: "sender",
    function: 'formatName'
  },
  {
    order: 2,
    des: "From Account",
    label: "From",
    display: true,
    sort: false,
    search: false,
    path: "fromAccount|from.phone"
  },
  {
    order: 3,
    des: "To Account",
    label: "To",
    display: true,
    sort: false,
    search: false,
    path: "toAccount|to.phone|phone"
  },
  {
    order: 4,
    des: "Sent Amount",
    label: "S.Amt",
    display: true,
    sort: false,
    search: false,
    path: "sentAmount",
    function: 'number',
    surfix: "fromMethod.method.symbol|exchange.from.symbol",
  },
  {
    order: 5,
    des: "Received Amount",
    label: "R.Amt",
    display: true,
    sort: false,
    search: false,
    path: "receivedAmount",
    function: "number",
    surfix: "toMethod.method.symbol|exchange.to.symbol",
  },
  {
    order: 6,
    des: "Gain",
    label: "Gain",
    display: true,
    sort: false,
    search: false,
    path: "rate",
    surfix: "toMethod.method.symbol|exchange.from.symbol",
    function: 'number',
  },
  {
    order: 7,
    des: "Date",
    label: "Date",
    display: true,
    sort: false,
    search: false,
    function: 'convertDate',
    path: "createdAt",
  },
  {
    order: 8,
    des: "Status format",
    label: "Status",
    display: true,
    sort: false,
    search: false,
    path: 'status',
  },
   {
    order: 10,
    des: "Sender Email",
    label: "Email",
    display: false,
    sort: false,
    search: false,
    path: "sender.email"
  },
  {
    order: 11,
    des: "From Pays",
    label: "Pays",
    display: false,
    sort: false,
    search: false,
    path: "sender.country.isoCode|sender.idOfCountry"
    },
  {
    order: 12,
    des: "From Method",
    label: "FromMtd",
    display: false,
    sort: false,
    search: false,
    path: "fromMethod.method.name"
  },
  {
    order: 13,
    des: "IP",
    label: "IP",
    display: false,
    sort: false,
    search: false,
    path: "ip"
    },

  {
      order: 14,
    des: "Platform",
    label: "Platform",
    display: false,
    sort: false,
    search: false,
    function:'extractPlatform',
    path: "userAgent"
    },

  {
    order: 15,
    des: "Origin",
    label: "Origin",
    display: false,
    sort: false,
    search: false,
    path: "location"
    },
    


  {
    order: 16,
    des: "Receiver Info",
    label: "Receiver",
    display: false,
    sort: false,
    search: false,
    path: "receiver",
    function: 'formatName'
    },
  {
      order: 17,
    des: "Receiver Id",
    label: "Receiver",
    display: false,
    sort: false,
    search: false,
    path: "idOfReceiver"
    },
  {
      order: 18,
    des: "Receiver Email",
    label: "Receiver",
    display: false,
    sort: false,
    search: false,
    path: "receiver.email|idOfReceiver"
    },
  {
      order: 19,
    des: "Receiver Country",
    label: "R.Pay",
    display: false,
    sort: false,
    search: false,
    path: "fromMethod.method.idOfCountry"
    },
  {
      order: 20,
    des: "To Method",
    label: "To",
    display: false,
    sort: false,
    search: false,
    path: "toMethod.method.name|toMethod.idOfMethod"
    },


  {
      order: 21,
    des: "Converted Amount",
    label: "C.Amount",
    display: false,
    sort: false,
    search: false,
    path: "convertedAmount"
    },
  {
      order: 22,
    des: "Rounded Gain",
    label: "rounded",
    display: false,
    sort: false,
    search: false,
    path: "rounded"
    },

  {
      order: 23,
    des: "Rate",
    label: "Rate",
    display: false,
    sort: false,
    search: false,
    path: "rate"
    },
  {
      order: 24,
    des: "Online Rate",
    label: "O.Rate",
    display: false,
    sort: false,
    search: false,
    path: "onlineRate"
    },
  {
      order: 25,
    des: "Agg. Rate",
    label: "Agg.Rate",
    display: false,
    sort: false,
    search: false,
    path: "aggRate"
  },

  {
      order: 26,
    des: "Receiver Name",
    label: "R.Name",
    display: false,
    sort: false,
    search: false,
    path: "name"
    },
  {
      order: 27,
    des: "Receiver Phone",
    label: "R.Phone",
    display: false,
    sort: false,
    search: false,
    path: "phone"
    },
    


  {
      order: 28,
    des: "Date Expiration",
    label: "D.Expire",
    display: false,
    sort: false,
    search: false,
    path: "expiredAt"
    },
  {
      order: 29,
    des: "Date Cancel",
    label: "D.cancel",
    display: false,
    sort: false,
    search: false,
    path: "cancelledAt"
    },

  {
      order: 30,
    des: "Status",
    label: "Status",
    display: false,
    sort: false,
    search: false,
    path: "fromAccount"
    },
  {
      order: 31,
    des: "Send Status",
    label: "S.Status",
    display: false,
    sort: false,
    search: false,
    path: "sendStatus"
    },
  {
      order: 32,
    des: "Send ID",
    label: "S.ID",
    display: false,
    sort: false,
    search: false,
    path: "sendId"
    },
  {
      order: 33,
    des: "Send Commission",
    label: "S.Rate",
    display: false,
    sort: false,
    search: false,
    path: "sendRate"
    },

  {
      order: 34,
    des: "Receive status",
    label: "R.Status",
    display: false,
    sort: false,
    search: false,
    path: "receiveStatus"
    },
  {
      order: 35,
    des: "Receive Id",
    label: "R.ID",
    display: false,
    sort: false,
    search: false,
    path: "receiveId"
    },
  {
      order: 36,
    des: "Receive Commission",
    label: "R.Rate",
    display: false,
    sort: false,
    search: false,
    path: "receiveRate"
    },

  {
      order: 37,
    des: "Redirect Url",
    label: "R.Url",
    display: false,
    sort: false,
    search: false,
    path: "receivePayUrl"
    },

  {
      order: 38,
    des: "From Manager",
    label: "F.Manager",
    display: false,
    sort: false,
    search: false,
    path: 'receive.idOfAgent'
    },
  {
      order: 39,
    des: "To Manager",
    label: "T.Manager",
    display: false,
    sort: false,
    search: false,
    path: 'send.idOfAgent'
  }, {
    order: 40,
    des: "reason",
    label: "reason",
    display: false,
    sort: false,
    search: false,
    path: "reason"
  },
  {
    order: 41,
    des: "Date Up",
    label: "up",
    display: false,
    sort: false,
    search: false,
    function: 'convertDate',
    path: "updatedAt",
  },

  {
    order: 42,
    des: "Editor",
    label: "UpBy",
    display: false,
    sort: false,
    search: false,
    path: "updatedBy",
  },

  {
    order: 43,
    des: "identity",
    label: "Id",
    display: false,
    sort: false,
    search: false,
    path: "id",
  },
  ];



function convertDate(date) {
  return moment.utc(date).format('DD-MM') + " " + moment.utc(date).format('HH:mm')
}

function isInit(transfer) {
  return transfer.status == "init"
}

function isPending(transfer) {
  return ["receiving", "received", "deposited","sending", "received", "deposited",].includes(transfer.status)
}

function isInsufficient(transfer) {
  return transfer.status == "insufficient"
}

function isError(transfer) {
  return ["error", "failed", "canceled", "rejected", "insufficient","refunded", "expired"].includes(transfer.status)
}

function isSuccess(transfer) {
  return ["withdrawn", "successful", "transferred",].includes(transfer.status)
}

export function getBadgeClassHelper(transfer) {
  if (isInit(transfer)) {
    return 'badge-soft-primary'; // Couleur bleue pour "pending"
  } else if (isPending(transfer)) {
    return 'badge-soft-warning'; // Couleur bleue pour "pending"
  } else if (isInsufficient(transfer)) {
    return 'badge-soft-secondary'; // Couleur orange pour "insufficient"
  } else if (isError(transfer)) {
    return 'badge-soft-danger'; // Couleur rouge pour "error"
  } else if (isSuccess(transfer)) {
    return 'badge-soft-success'; // Couleur verte pour "success"
  }
  return 'badge-soft-dark'; // Couleur par défaut
}

export  function  getBadgeLabelHelper(transfer) {
  if (isSuccess(transfer)) {
    return 'success'; // Label personnalisé pour "success"
  }
  return transfer.status; // Utilise le statut brut par défaut
}

//   function  truncateEmail(email) {
//       if (email.length > 15) {
//         return email.slice(0, 13) + '...'; // Récupère les 17 premiers caractères et ajoute "..."
//       }
//       return email; // Retourne l'email tel quel si sa longueur est inférieure ou égale à 20
//     };



export function getValueByPath(obj, config) {
    const path = config.path;

    if (!path) return undefined;

    const tryGet = (o, p) => {
      const parts = p.split(".");
      let current = o;

      for (let part of parts) {
        if (current == null || typeof current !== "object") return undefined;
          current = current[part];
        }
      return current;
    };


    const getPrefixValue = (o, fix, t) => {
      const path = t == 0 ? fix.prefix : fix.surfix;

      if (!path) return '';

      if (path.includes("|")) {
        const paths = path.split("|");
        for (const p of paths) {
          const value = tryGet(o, p.trim());
          if (value !== undefined && value !== null) {
            return ` ${value} `;
          }
        }
        return '';
      }
      const value = tryGet(o, path.trim())
      return value ? ` ${value} ` : '';
    }


  if (path.includes("|")) {
    const paths = path.split("|");
    for (const p of paths) {
      const value = tryGet(obj, p.trim());
      if (value !== undefined && value !== null) {
         if (config.function) {
          const resp = applyFunction(obj, value, config.function);
          return `${getPrefixValue(obj, config, 0)}${resp}${getPrefixValue(obj, config, 1)}`
        }
        return `${getPrefixValue(obj, config, 0)}${value}${getPrefixValue(obj, config, 1)}`;
      }
    }
    return undefined;
  }
  const value = tryGet(obj,path);
  if (config.function) {
    const resp = applyFunction(obj, value, config.function);
    return `${getPrefixValue(obj, config, 0)}${resp}${getPrefixValue(obj, config, 1)}`
  }
  return  `${getPrefixValue(obj, config, 0)}${value}${getPrefixValue(obj, config, 1)}`;
}

export function getValueForSort(obj, path) {
 
  if (!path) return undefined;

  const tryGet = (o, p) => {
    const parts = p.split(".");
    let current = o;

    for (let part of parts) {
      if (current == null || typeof current !== "object") return undefined;
      current = current[part];
    }
    return current;
  };

  


  if (path.includes("|")) {
    const paths = path.split("|");
    for (const p of paths) {
      const value = tryGet(obj, p.trim());
      console.log(p)
      if (value !== undefined && value !== null) {
        if (p == 'sender' || p == 'receiver') {
          return [value?.lastName??'', value?.firstName??''].join(' ')
        }
        return value;
      }
    }
    return undefined;
  }
  const value = tryGet(obj,path);

  console.log(value);
    if( path=='receiver' || path=='sender'){
      return [value?.lastName??'', value?.firstName??''].join(' ')
    }
    return value;

 
}




function formatName(user) {
  if (!user) return '';

  const prenoms = user.firstName ? user.firstName.trim().split(' ').filter(Boolean) : [];
  const noms = user.lastName ? user.lastName.trim().split(' ').filter(Boolean) : [];

  const mots = [...noms, ...prenoms];

  // Aucun mot disponible
  if (mots.length === 0) return '';

  // Un seul mot dans un seul champ → on le retourne formaté
  if (mots.length === 1) {
    const seulMot = mots[0];
    return seulMot.charAt(0).toUpperCase() + seulMot.slice(1);
  }

  // Trouver le mot le plus court (en cas d'égalité, on prend le dernier)
  let motCourt = mots[0];
  for (let i = 1; i < mots.length; i++) {
    if (
      mots[i].length < motCourt.length ||
      (mots[i].length === motCourt.length && i > mots.indexOf(motCourt))
    ) {
      motCourt = mots[i];
    }
  }

  // Initiales de tous les autres mots
  const initiales = mots
    .filter(m => m !== motCourt)
    .map(m => m[0].toUpperCase())
    .join('. ');

  const motFormate = motCourt.charAt(0).toUpperCase() + motCourt.slice(1);
  return initiales ? `${initiales}. ${motFormate}` : motFormate;
}

function extractPlatform(userAgent) {
    if (!userAgent) return '';
    const match = userAgent.match(/device:[^;]*;[^;]*;[^;]*;([^,\n]+)/);
    if (match) {
      return match[1].trim();
    }
    return ''; 
  }



function applyFunction(object, value,  fn){
  switch(fn){
    case null:
    case undefined:
    case '':
      return value;
    case 'getBadgeLabelHelper':
      return getBadgeLabelHelper(object);
    case 'convertDate':
    case 'date':
      return convertDate(value);
    case 'number':
      return  Number(value);
    case 'formatName':
      return  formatName(value);
     case 'extractPlatform':
        return extractPlatform(value);
    default:
      return value;
  }
}

